import React, { useState } from "react";
import api from "../services/api";

export default function ForgotPassword({ onBack, standalone = false }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      setLoading(true);
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      console.error("forgot-password error:", e?.response?.status, e?.message);

      const status = e?.response?.status;
      const detail = e?.response?.data?.detail;

      if (status === 404) {
        setErr(detail || "E-mail não cadastrado. Verifique se digitou corretamente ou crie uma conta.");
      } else {
        setErr(detail || "Erro ao enviar email de recuperação. Tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  const containerClass = standalone
    ? "min-h-screen flex items-center justify-center bg-gray-50 px-4"
    : "";

  const cardClass = standalone
    ? "w-full max-w-md bg-white border rounded-xl shadow-sm p-6"
    : "";

  return (
    <div className={containerClass}>
      <div className={cardClass}>
        {standalone && (
          <>
            <h1 className="text-xl font-semibold">Recuperar senha</h1>
            <p className="text-sm text-gray-600 mt-1">
              Informe seu e-mail para receber um link seguro de redefinição.
            </p>
          </>
        )}

        {sent ? (
          <div className="mt-4 p-3 rounded-md bg-emerald-50 text-emerald-700 text-sm">
            Enviamos um link de recuperação para o e-mail informado.
            Verifique sua caixa de entrada e também a pasta de spam.
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-4 space-y-3">
            <div>
              <label className="text-sm font-medium">Seu e-mail</label>
              <input
                type="email"
                className="mt-1 w-full border rounded-md px-3 py-2 focus:ring-emerald-500 focus:border-emerald-500"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="voce@clinica.com.br"
                required
              />
              <p className="text-xs text-gray-500 mt-1">
                Enviaremos um link seguro para você criar uma nova senha.
              </p>
            </div>

            {err && <div className="text-sm text-red-600">{err}</div>}

            <button
              type="submit"
              disabled={loading}
              className="w-full inline-flex justify-center items-center px-4 py-2 rounded-md bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-60"
            >
              {loading ? "Enviando..." : "Enviar link de recuperação"}
            </button>

            {onBack && (
              <button
                type="button"
                onClick={onBack}
                className="w-full mt-2 text-sm text-gray-600 hover:text-gray-800"
              >
                Voltar ao login
              </button>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
